import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType, ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoPlan";

export default class VentanaPlan extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.PLAN+estadoComp.domain.screen.idPlan;
        this.estadoComp = estadoComp;
    }

    static nuevaVentanaEnModoCrear() {
        return new VentanaPlan(getEstadoInicial());
    }

    static nuevaVentanaEnModoOk(idCliente) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idPlan = idCliente;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        return new VentanaPlan(estadoComp);
    }


    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaPlan)) {
            return false;
        }
        if(this.id === ventanaAAbrir.id){
            return true;
        }
        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaPlan(this.estadoComp);
        nuevaVentana.posicionZ = this.posicionZ;
        return nuevaVentana;
    }
}
